import {IDataSourceAdapter} from '~/lib/dataSource';
import {ID} from '~/lib/model';
import {
    copyBidder,
    createBidder,
    createBidderGroup,
    createPreTargetingConfig,
    createPreTargetingVariable,
    deleteBidder,
    deleteBidderGroup,
    deletePreTargetingConfig,
    deletePreTargetingVariable,
    fetchBidders,
    fetchBidderGroups,
    fetchPreTargetingConfigs,
    fetchPreTargetingVariables,
    IBiddersFilter,
    IBidderGroupsFilter,
    updateBidder,
    updateBidderGroup,
    updateBidders,
    updatePreTargetingConfig,
    updatePreTargetingVariable
} from '~/modules/Bidders/api';
import {IBidder} from '~/modules/Bidders/models/Bidder';
import {adaptBidderSummary, IBidderSummary} from '~/modules/Bidders/models/BidderSummary';
import {IBidderGroup} from '~/modules/Bidders/models/BidderGroup';
import {IPreTargetingConfig, IPreTargetingVariable} from '~/modules/Bidders/models/PreTargeting';

export const biddersAdapter: IDataSourceAdapter<IBidderSummary, IBiddersFilter> = {
    fetchRecords: fetchBidders,
    updateRecord: (bidder) => updateBidder(bidder as IBidder).then(adaptBidderSummary),
    updateRecords: (bidders) => updateBidders(bidders as IBidder[]).then(result => Array.isArray(result)
        ? result.map(adaptBidderSummary)
        : result as any),
    createRecord: (bidder) => createBidder(bidder as IBidder).then(adaptBidderSummary),
    copyRecord: (id) => copyBidder(id).then(adaptBidderSummary),
    deleteRecord: (bidder) => deleteBidder(bidder as IBidder)
};

export const preTargetingConfigsAdapter: IDataSourceAdapter<IPreTargetingConfig> = {
    fetchRecords: (bidderId: ID) => fetchPreTargetingConfigs(bidderId),
    updateRecord: updatePreTargetingConfig,
    createRecord: createPreTargetingConfig,
    deleteRecord: deletePreTargetingConfig
};


export const preTargetingVariablesAdapter: IDataSourceAdapter<IPreTargetingVariable> = {
    fetchRecords: (preTargetingId: ID) => fetchPreTargetingVariables(preTargetingId),
    updateRecord: updatePreTargetingVariable,
    createRecord: createPreTargetingVariable,
    deleteRecord: deletePreTargetingVariable
};

export const bidderGroupsAdapter: IDataSourceAdapter<IBidderGroup, IBidderGroupsFilter> = {
    fetchRecords: filter => fetchBidderGroups(filter),
    createRecord: createBidderGroup,
    updateRecord: updateBidderGroup,
    deleteRecord: deleteBidderGroup
};
